<!-- <h3 class="text-center align-middle gradient-text">Vasavi College of Engineering Dashboard</h3> -->

<div class="row">
  <div class="col-xxl-3 col-md-6 d-flex align-items-stretch">
      <div class="card card-premium info-card sales-card">
          <div class="filter">
                <a class="icon" href="#" data-bs-toggle="dropdown"><i class="bi bi-three-dots"></i></a>
                <ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                  <li class="dropdown-header text-start">
                    <h6>Filter</h6>
                  </li>

                  <li><a class="dropdown-item" (click)="setFilter('total'); $event.stopPropagation()">Total</a></li>
                  <li><a class="dropdown-item" (click)="setFilter('teaching'); $event.stopPropagation()">Teaching</a></li>
                  <li><a class="dropdown-item" (click)="setFilter('nonTeaching'); $event.stopPropagation()">Non-Teaching</a></li>
                </ul>
          </div>
          <div class="card-body">             
              <!-- routerLink="/essl/staffparticulars"> -->
              <h5 class="card-title">Faculty Summary<span>| {{filterLabel}}</span></h5>

              <div class="d-flex align-items-center">
              <!-- <div class="card-icon rounded-circle d-flex align-items-center justify-content-center">
                  <i class="bi bi-people"></i>
              </div> -->
              <div class="ps-0 w-100 flex-fill">
                  <!-- <h6>{{displayCount}}</h6> -->
                    <div class="table-responsive">
                      <table class="table table-sm mb-0 card-table-wrapper">
                          <thead>
                              <tr class="small">
                                  <th>Designation</th>
                                  <th class="text-end">Count</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr *ngFor="let row of orderedDesignationCounts" class="clickable-row hover-row"
                              (click)="openDesignationModal(row.designation)">
                                  <td><small>{{ row.designation }}</small></td>
                                  <td class="text-end"><small>{{ row.count }}</small></td>
                              </tr>
                              <tr class="clickable-row "
                              (click)="openStaffModal(filterLabel)">
                                  <td>
                                      <span class="pt-1 fw-bold">Total:</span> 
                                  </td>
                                  <td class="text-end fw-bold">
                                    <small>
                                      {{totalCount}}
                                    </small>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
  </div>
  <div class="col-xxl-3 col-md-6 d-flex align-items-stretch">
      <div class="card card-premium info-card revenue-card">
          <div class="filter">
                <!-- <input type="date" class="form-control"
                [value]="selectedDate"
                (change)="onDateChanged($event)"> -->
                <a class="icon" href="#" data-bs-toggle="dropdown"><i class="bi bi-three-dots"></i></a>
                <ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                  <li class="dropdown-header text-start">
                    <h6>Filter</h6>
                  </li>
                  <!-- <li><a class="dropdown-item" (click)="setStudentFilter('total'); $event.stopPropagation()">Total</a></li>
                  <li><a class="dropdown-item" (click)="setStudentFilter('1'); $event.stopPropagation()">First Year</a></li>
                  <li><a class="dropdown-item" (click)="setStudentFilter('2'); $event.stopPropagation()">Second Year</a></li>
                  <li><a class="dropdown-item" (click)="setStudentFilter('3'); $event.stopPropagation()">Third Year</a></li>
                  <li><a class="dropdown-item" (click)="setStudentFilter('4'); $event.stopPropagation()">Fourth Year</a></li> -->
                </ul>
          </div>
          <div class="card-body clickable" routerLink="/essl/employee">
              <h5 class="card-title mb-0">Staff Attendance Status<span>| Total</span></h5>
              <small class = "mt-0">Today's attendance: {{ currentDate | date: 'dd-MM-yyyy'}}</small>
              <div class="d-flex align-items-center">
              <!-- <div class="card-icon rounded-circle d-flex align-items-center justify-content-center">
                  <i class="bi bi-people"></i>
              </div> -->
              <div class="ps-3 w-100 flex-fill">       
                  <app-day-absentees></app-day-absentees>
              </div>
              </div>
          </div>
      </div>
  </div>
  <div class="col-xxl-3 col-md-6 d-flex align-items-stretch">
                  <div class="card card-premium info-card revenue-card">
                    <div class="filter">
                <a class="icon" href="#" data-bs-toggle="dropdown"><i class="bi bi-three-dots"></i></a>
                <ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                  <li class="dropdown-header text-start">
                    <h6>Filter</h6>
                  </li>
                  <li><a class="dropdown-item" (click)="setStudentFilter('total'); $event.stopPropagation()">Total</a></li>
                  <li><a class="dropdown-item" (click)="setStudentFilter('1'); $event.stopPropagation()">First Year</a></li>
                  <li><a class="dropdown-item" (click)="setStudentFilter('2'); $event.stopPropagation()">Second Year</a></li>
                  <li><a class="dropdown-item" (click)="setStudentFilter('3'); $event.stopPropagation()">Third Year</a></li>
                  <li><a class="dropdown-item" (click)="setStudentFilter('4'); $event.stopPropagation()">Fourth Year</a></li>
                </ul>
          </div>
          <div class="card-body pt-1 py-1">
              <h5 class="card-title mb-0">Student's Strength<span>| {{ studentYearLabel }}</span></h5>
              <div class="d-flex align-items-center">
              <!-- <div class="card-icon rounded-circle d-flex align-items-center justify-content-center">
                  <i class="bi bi-people"></i>
              </div> -->
              <div class="ps-0 w-100 flex-fill">
                  <!-- <h6>145</h6> -->
                  <div class="table-responsive"> 
                    <table class="table table-sm">
                      <thead class=""> 
                        <tr> <th rowspan="2"><small>Year</small></th> 
                          <!-- <th *ngFor="let sec of allSections" colspan="3"> {{ sec }} </th> 
                           <th rowspan="2">YT</th> --> 
                          </tr> 
                          <tr> 
                            <ng-container *ngFor="let sec of allSections"> 
                              <!-- <th>M</th> <th>F</th> --> 
                               <th><small>{{sec}}</small></th> 
                            </ng-container> <th><small>Total</small></th>
                          </tr> 
                      </thead> 
                      <tbody> 
                        <tr *ngFor="let row of yearWiseGenderSummary"> 
                          <td><small>
                            {{ getYearLabel(row.year) }}
                          </small>
                        </td> 
                          <ng-container *ngFor="let sec of allSections"> 
                            <!-- <td class="clickable-row" 
                             (click)="openStudentModal(row.year, sec, 'Male')"> 
                             {{getSection(row,sec).M}} --> 
                             <!-- {{ row.sections[sec].M || 0 }} --> 
                              <!-- </td> --> 
                               <!-- <td class="clickable-row" 
                                (click)="openStudentModal(row.year, sec, 'Female')"> 
                                {{getSection(row,sec).M}} --> 
                                <!-- {{ row.sections[sec].F || 0 }} --> 
                                <!-- </td> --> 
                                 <td class="clickable-row" 
                                 (click)="openStudentModal(row.year, row.semester, sec, 'total')"> 
                                 <small>
                                   {{getSection(row,sec).total}} 
                                 </small>
                                 <!-- {{ row.sections[sec].total || 0 }} --> 
                                  </td> 
                                </ng-container> <td class="fw-bold clickable-row" 
                                (click)="openYearTotal(row.year)"> 
                                <small>
                                  {{ row.total }}
                                </small>
                               </td> 
                              </tr> <!-- <tr> <td class="cursor-pointer" 
                                (click)="openGrandTotal()"> 
                                {{ grandTotal.total }} </td> </tr> --> 
                                </tbody> 
                              <tfoot> 
                                <tr class="fw-bold table-light"> 
                                  <td>Total:</td> 
                                  <ng-container *ngFor="let sec of allSections"> 
                                    <!-- <td class="clickable-row" 
                                     (click)="openSectionTotal(sec, 'Male')"> 
                                     {{ grandTotal.sections[sec].M || 0 }} </td>
                                    <td class="clickable-row" 
                                    (click)="openSectionTotal(sec, 'Female')"> 
                                    {{ grandTotal.sections[sec].F || 0 }} </td> --> 
                                     <td class="clickable-row text-muted" 
                                     (click)="openSectionGTotal(sec)"> 
                                     <!-- {{ grandTotal.sections[sec].total || 0 }} --> </td> 
                                    </ng-container> <td class="clickable-row" 
                                    (click)="openGrandTotal()">
                                    <small>
                                      {{ grandTotal.total }} 
                                    </small> 
                                  </td> 
                                  </tr> 
                                </tfoot> 
                              </table> 
                        <!-- <span class="text-success small pt-1 fw-bold">
                          12%</span> 
                          <span class="text-muted small pt-2 ps-1">increase</span> -->
                  </div>

                    <!-- <div class="table-responsive">
                      <table class="table table-sm text-center table-striped">
                        <thead class="">
                          <tr>
                            <th rowspan="2">Year</th>

                            <th *ngFor="let sec of allSections" colspan="3">
                              {{ sec }}
                            </th>

                            <th rowspan="2">YT</th>
                          </tr>

                          <tr>
                            <ng-container *ngFor="let sec of allSections">
                              <th>M</th>
                              <th>F</th>
                              <th>{{sec}}</th>
                            </ng-container>
                            <th>Total</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr *ngFor="let row of yearWiseGenderSummary">
                            <td>{{ row.year }}</td>

                            <ng-container *ngFor="let sec of allSections">
                              <td class="clickable-row"
                                  (click)="openStudentModal(row.year, sec, 'Male')">
                                  {{getSection(row,sec).M}}
                                {{ row.sections[sec].M || 0 }}
                              </td>

                              <td class="clickable-row"
                                  (click)="openStudentModal(row.year, sec, 'Female')">
                                  {{getSection(row,sec).M}}
                                {{ row.sections[sec].F || 0 }}
                              </td>
                              <td class="clickable-row"
                                  (click)="openStudentModal(row.year, sec, 'total')">
                                  {{getSection(row,sec).total}}
                                {{ row.sections[sec].total || 0 }}
                              </td>
                            </ng-container>  
                            <td class="fw-bold clickable-row"
                                (click)="openYearTotal(row.year)">
                              {{ row.total }}
                            </td>
                          </tr>
                          <tr>
                              <td class="cursor-pointer"
                              (click)="openGrandTotal()">
                            {{ grandTotal.total }}
                          </td>
                          </tr>
                        </tbody>
                        <tfoot>
                            <tr class="fw-bold table-light">
                              <td>Total:</td>

                              <ng-container *ngFor="let sec of allSections">
                                <td class="clickable-row"
                                    (click)="openSectionTotal(sec, 'Male')">
                                  {{ grandTotal.sections[sec].M || 0 }}
                                </td>

                                <td class="clickable-row"
                                    (click)="openSectionTotal(sec, 'Female')">
                                  {{ grandTotal.sections[sec].F || 0 }}
                                </td>
                                <td class="clickable-row"
                                    (click)="openSectionGTotal(sec)">
                                  {{ grandTotal.sections[sec].total || 0 }}
                                </td>
                              </ng-container>

                              <td class="clickable-row"
                                  (click)="openGrandTotal()">
                                {{ grandTotal.total }}
                              </td>
                            </tr>
                          </tfoot>

                      </table>
                    <span class="text-success small pt-1 fw-bold">12%</span> <span class="text-muted small pt-2 ps-1">increase</span>
                    </div> -->
                    
                    <!-- <div class="table-responsive">
                      <table class="table table-sm text-center table-striped">
                        
               
                        <thead>
                          <tr>
                            <th>Section</th>
                            <th *ngFor="let row of yearWiseGenderSummary">
                              {{ row.year }}
                            </th>
                            <th>Total</th>
                          </tr>
                        </thead>

               
                        <tbody>
                          <tr *ngFor="let sec of allSections">
                            <td class="fw-bold">{{ sec }}</td>

                            <ng-container *ngFor="let row of yearWiseGenderSummary">
                              <td class="clickable-row"
                                  (click)="openStudentModal(row.year, sec, 'total')">
                                {{ getSection(row, sec).total }}
                              </td>
                            </ng-container>

       
                            <td class="fw-bold clickable-row"
                                (click)="openSectionGTotal(sec)">
                              {{ getSectionGrandTotal(sec) }}
                            </td>
                          </tr>
                        </tbody>

 
                        <tfoot>
                          <tr class="fw-bold table-light">
                            <td>Total</td>

                            <ng-container *ngFor="let row of yearWiseGenderSummary">
                              <td class="clickable-row"
                                  (click)="openYearTotal(row.year)">
      
                              </td>
                            </ng-container>

                            <td class="clickable-row"
                                (click)="openGrandTotal()">
                              {{ grandTotal.total }}
                            </td>
                          </tr>
                        </tfoot>

                      </table>
                    </div> -->
              </div>
              </div>
          </div>
      </div>
  </div>
  <div class="col-xxl-3 col-md-6 d-flex align-items-stretch p-0">
      <div class="card info-card revenue-card">
          <div class="filter">
                <a class="icon" href="#" data-bs-toggle="dropdown"><i class="bi bi-three-dots"></i></a>
                <ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                  <li class="dropdown-header text-start">
                    <h6>Filter</h6>
                  </li>
                  <!-- <li><a class="dropdown-item" (click)="setStudentFilter('total'); $event.stopPropagation()">Total</a></li>
                  <li><a class="dropdown-item" (click)="setStudentFilter('1'); $event.stopPropagation()">First Year</a></li>
                  <li><a class="dropdown-item" (click)="setStudentFilter('2'); $event.stopPropagation()">Second Year</a></li>
                  <li><a class="dropdown-item" (click)="setStudentFilter('3'); $event.stopPropagation()">Third Year</a></li>
                  <li><a class="dropdown-item" (click)="setStudentFilter('4'); $event.stopPropagation()">Fourth Year</a></li> -->
                </ul>
          </div>
          <div class="card-body">
              <h5 class="card-title">Placements <span>| IT</span></h5>
              <div class="d-flex align-items-center">
              <!-- <div class="card-icon rounded-circle d-flex align-items-center justify-content-center">
                  <i class="bi bi-people"></i>
              </div> -->
              <div class="ps-0 w-100 flex-fill">
                  <app-placement-report></app-placement-report>
              </div>
              </div>
          </div>
      </div>
  </div>
</div>
<div class="row">
  <div class="col-xxl-6 col-md-12 d-flex align-items-stretch">
      <div class="card card-premium info-card customers-card">
          <div class="filter">
                <a class="icon" href="#" data-bs-toggle="dropdown"><i class="bi bi-three-dots"></i></a>
                <ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                  <li class="dropdown-header text-start">
                    <h6>Filter</h6>
                  </li>
  
                  <li *ngFor="let R of academicYears;let i = index;">
                    <a class="dropdown-item" (click)="previousAcademicYearsAnalysis(i); $event.stopPropagation()">{{R.academicFullYear}}</a>
                  </li>
                  <!-- <li><a class="dropdown-item" href="#">Second Year</a></li>
                  <li><a class="dropdown-item" href="#">Third Year</a></li>
                  <li><a class="dropdown-item" href="#">Fourth Year</a></li> -->
                </ul>
          </div>
          <div class="card-body">
              <h5 class="card-title mb-0">Student's Attendance Summary <span>| {{academicFullYear}} </span></h5>
  
              <div class="d-flex align-items-center">
              <!-- <div class="card-icon rounded-circle d-flex align-items-center justify-content-center">
                  <i class="bi bi-bar-chart"></i>
              </div> -->
              <div class="w-100">
                <app-attendance-percentage
                [academicYearId] = "academicYearId"
                [academicFullYear] = "academicFullYear"
                ></app-attendance-percentage>
              </div>
              </div>
          </div>
      </div>
  </div>
  <div class="col-xxl-6 col-md-12 d-flex align-items-stretch">
      <div class="card card-premium info-card customers-card">
          <div class="filter">
                <a class="icon" href="#" data-bs-toggle="dropdown"><i class="bi bi-three-dots"></i></a>
                <ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                  <li class="dropdown-header text-start">
                    <h6>Filter</h6>
                  </li>
  
                  <li *ngFor="let R of regulationYears;let i = index;">
                    <a class="dropdown-item" (click)="regulationAnalysis(i); $event.stopPropagation()">{{R}}</a>
                  </li>
                  <!-- <li><a class="dropdown-item" href="#">Second Year</a></li>
                  <li><a class="dropdown-item" href="#">Third Year</a></li>
                  <li><a class="dropdown-item" href="#">Fourth Year</a></li> -->
                </ul>
          </div>
          <div class="card-body clickable"
          (click)="navigateToCgpa()">
              <h5 class="card-title">CGPA Analysis <span>| {{selectedYearLabel}}</span></h5>
              <div class="d-flex align-items-center">
              <!-- <div class="card-icon rounded-circle d-flex align-items-center justify-content-center">
                  <i class="bi bi-bar-chart"></i>
              </div> -->
              <div class="ps-3 w-100">
                <!-- <div *ngIf="!loading && rfinalCgpaDetails.length > 0" class="mt-1 chart-wrapper">
                  <canvas id="cgpaBarChart"></canvas>
                </div> -->
                 <div *ngIf="!loading && rfinalCgpaDetails.length > 0" class="mt-1 chart-wrapper">
                  <canvas #cgpaCanvas></canvas>
                </div>
                  <!-- <h6>145</h6>
                  <span class="text-success small pt-1 fw-bold">12%</span> <span class="text-muted small pt-2 ps-1">increase</span> -->
              </div>
              </div>
          </div>
      </div>
  </div>
</div>

<div>
  <app-exam-register-students-regular></app-exam-register-students-regular>
</div>

<div>
  <app-exam-register-students></app-exam-register-students>
</div>

<div class="row" *ngIf="username === 'hodit'">
  <app-internet-speeds-check></app-internet-speeds-check>
</div>


<!-- <app-home></app-home> -->
<!-- <div class="row">
  <div class="col-xxl-6 col-md-6 d-flex align-items-stretch">
      <div class="card info-card sales-card">
          <div class="filter">
                <a class="icon" href="#" data-bs-toggle="dropdown"><i class="bi bi-three-dots"></i></a>
                <ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                  <li class="dropdown-header text-start">
                    <h6>Filter</h6>
                  </li>
                  <li><a class="dropdown-item" href="#">First Year</a></li>
                  <li><a class="dropdown-item" href="#">Second Year</a></li>
                  <li><a class="dropdown-item" href="#">Third Year</a></li>
                  <li><a class="dropdown-item" href="#">Fourth Year</a></li>
                </ul>
          </div>
          <div class="card-body" >
              <h5 class="card-title">Attendance <span>| Today</span></h5>

              <div class="d-flex align-items-center">
              <div class="card-icon rounded-circle d-flex align-items-center justify-content-center">
                  <i class="bi bi-clipboard-check"></i>
              </div>
              <div class="ps-3">
                  <h6>145</h6>
                  <span class="text-success small pt-1 fw-bold">12%</span> <span class="text-muted small pt-2 ps-1">increase</span>
                  <app-home></app-home>
              </div>
              </div>
          </div>
      </div>
  </div>
</div>  -->

<!-- Modal Backdrop -->
<div class="modal-backdrop fade show" *ngIf="showStaffModal"></div>

<div
  class="modal fade show d-block"
  *ngIf="showStaffModal"
  tabindex="-1"
>
  <div class="modal-dialog modal-xl modal-dialog-scrollable">
    <div class="modal-content glass-modal-content">

      <div class="modal-header premium-modal-header">
        <h5 class="modal-title">{{ selectedTitle }}</h5>
        <button type="button" class="btn btn-close" (click)="showStaffModal=false"></button>
      </div>

      <div class="modal-body p-0">
        <table class="premium-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Staff No</th>
              <th>Name</th>
              <th>Designation</th>
              <th>Type</th>
              <th>Mobile</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let s of paginatedStaffList; let i= index">
              <td>{{ (staffCurrentPage - 1) * staffPageSize + i + 1 }}</td>
              <td (click)="openStaffDetails(s.staffNo)" class="clickable text-decoration-underline text-primary fw-bold">{{ s.staffNo }}</td>
              <td>{{ s.staffName | titlecase}}</td>
              <td>{{ s.designation | titlecase}}</td>
              <td>
                <span [ngClass]="s.employeeType === 'T' ? 'badge-teaching' : 'badge-non-teaching'">
                  {{ s.employeeType === 'T' ? 'Teaching' : 'Non-Teaching' }}
                </span>
              </td>
              <td>{{ s.mobileNo }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer py-2">
        <div class="d-flex justify-content-between align-items-center w-100">
          <small class="text-muted ms-3">
            Showing {{ (staffCurrentPage - 1) * staffPageSize + 1 }}
            –
            {{ Math.min(staffCurrentPage * staffPageSize, selectedStaffList.length) }}
            of {{ selectedStaffList.length }}
          </small>
          <app-pagination
            [totalItems]="selectedStaffList.length"
            [itemsPerPage]="staffPageSize"
            (pageChange)="changeStaffPage($event)"
          ></app-pagination>
          <button type="button" class="btn btn-sm btn-outline-secondary me-3" (click)="showStaffModal=false">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- backdrop -->
<div class="modal-backdrop fade show" *ngIf="showStaffModal"></div>


<!-- Student List Modal -->
<div class="modal fade show d-block" *ngIf="showModal" tabindex="-1">
  <div class="modal-dialog modal-xl modal-dialog-scrollable">
    <div class="modal-content glass-modal-content">

      <!-- Modal Header -->
      <div class="modal-header premium-modal-header">
        <h6 class="modal-title">
          {{ modalTitle }}
          <span class="text-muted small ms-2">
            ({{ selectedStudents.length }} students)
          </span>
        </h6>
        <div class="d-flex gap-2 ms-auto me-3">
          <button
            type="button"
            class="btn btn-sm btn-success"
            title="Download Excel"
            (click)="downloadExcel()">
            <i class="bi bi-file-earmark-excel"></i>
          </button>

          <button
            type="button"
            class="btn btn-sm btn-danger"
            title="Download PDF"
            (click)="downloadPDF()">
            <i class="bi bi-file-earmark-pdf"></i>
          </button>
          <!-- <button
            type="button"
            class="btn-close ms-2"
            data-bs-dismiss="modal"
            aria-label="Close">
          </button> -->
          <button type="button" class="btn-close" (click)="closeModal()"></button>
        </div>
      </div>

      <!-- Modal Body -->
      <div class="modal-body p-0">
        <table class="premium-table">
          <thead class="sticky-top">
            <tr>
              <th>#</th>
              <th>HT No</th>
              <th>Name</th>
              <th>Gender</th>
              <th>Father Name</th>
              <!-- <th>Year</th> -->
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let s of paginatedStudents; let i = index">
              <td>{{ pageStartIndex + i + 1 }}</td>
              <td class="fw-bold">{{ s.htNo }}</td>
              <td>{{ s.studentName | titlecase}}</td>
              <td>{{ s.genderName }}</td>
              <td>{{ s.fatherName | titlecase }}</td>
              <!-- <td>{{ s.year }}</td> -->
            </tr>

            <tr *ngIf="paginatedStudents.length === 0">
              <td colspan="6" class="text-center text-muted py-3">
                No students found
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Modal Footer (Pagination) -->
      <div class="modal-footer py-2">
        <div class="d-flex justify-content-between align-items-center w-100">

          <small class="text-muted ms-3">
            Showing {{ pageStartIndex + 1 }}
            –
            {{ pageStartIndex + paginatedStudents.length }}
            of {{ selectedStudents.length }}
          </small>

          <app-pagination
            [totalItems]="selectedStudents.length"
            [itemsPerPage]="pageSize"
            (pageChange)="changePage($event)"
          ></app-pagination>

          <button type="button" class="btn btn-sm btn-outline-secondary me-3" (click)="closeModal()">Close</button>

        </div>
      </div>

    </div>
  </div>
</div>

<!-- Modal backdrop -->
<div class="modal-backdrop fade show" *ngIf="showModal"></div>




